import { html, css } from '@design.estate/dees-element';

export const demoFunc = () => {
  return html`
    <style>
      ${css`
        .demoBox {
          background: #000000;
          padding: 40px;
          min-height: 100vh;
          box-sizing: border-box;
        }

        .demo-section {
          margin-bottom: 32px;
        }

        .demo-title {
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 16px;
          font-family: 'Geist Sans', sans-serif;
        }

        .demo-description {
          color: #999;
          font-size: 14px;
          margin-bottom: 24px;
          font-family: 'Geist Sans', sans-serif;
        }
      `}
    </style>
    <div class="demoBox">
      <div class="demo-section">
        <h2 class="demo-title">Basic Button Groups</h2>
        <p class="demo-description">Button groups without labels for simple grouping</p>
        
        <dees-button-group>
          <dees-button>Option 1</dees-button>
          <dees-button>Option 2</dees-button>
          <dees-button>Option 3</dees-button>
        </dees-button-group>
      </div>

      <div class="demo-section">
        <h2 class="demo-title">Labeled Button Groups</h2>
        <p class="demo-description">Button groups with descriptive labels</p>
        
        <dees-button-group label="View Mode:">
          <dees-button type="highlighted">Grid</dees-button>
          <dees-button>List</dees-button>
          <dees-button>Cards</dees-button>
        </dees-button-group>
      </div>

      <div class="demo-section">
        <h2 class="demo-title">Multiple Groups</h2>
        <p class="demo-description">Multiple button groups used together</p>
        
        <div style="display: flex; gap: 16px; flex-wrap: wrap;">
          <dees-button-group label="Dataset:">
            <dees-button type="highlighted">System</dees-button>
            <dees-button>Network</dees-button>
            <dees-button>Sales</dees-button>
          </dees-button-group>
          
          <dees-button-group label="Time Range:">
            <dees-button>1H</dees-button>
            <dees-button type="highlighted">24H</dees-button>
            <dees-button>7D</dees-button>
            <dees-button>30D</dees-button>
          </dees-button-group>
          
          <dees-button-group label="Actions:">
            <dees-button>Refresh</dees-button>
            <dees-button>Export</dees-button>
          </dees-button-group>
        </div>
      </div>

      <div class="demo-section">
        <h2 class="demo-title">Vertical Button Groups</h2>
        <p class="demo-description">Button groups with vertical layout</p>
        
        <div style="display: flex; gap: 24px;">
          <dees-button-group direction="vertical" label="Navigation:">
            <dees-button>Dashboard</dees-button>
            <dees-button type="highlighted">Analytics</dees-button>
            <dees-button>Reports</dees-button>
            <dees-button>Settings</dees-button>
          </dees-button-group>
          
          <dees-button-group direction="vertical">
            <dees-button>Add Item</dees-button>
            <dees-button>Edit Item</dees-button>
            <dees-button>Delete Item</dees-button>
          </dees-button-group>
        </div>
      </div>

      <div class="demo-section">
        <h2 class="demo-title">Mixed Button Types</h2>
        <p class="demo-description">Different button types within groups</p>
        
        <dees-button-group label="Status:">
          <dees-button type="success">Active</dees-button>
          <dees-button>Pending</dees-button>
          <dees-button type="danger">Inactive</dees-button>
        </dees-button-group>
      </div>
    </div>
  `;
};